import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import CustomSelectableDropdown from '@components/CustomSelectableDropdown';
import ImageUpload from '@components/ImageUpload';
import ModalContainer from '@components/modals/ModalContainer';
import { toastError } from '@components/Toast';

import { closeLoader, openLoader } from '@store/actions/LoaderAction';

import { fetchSubCategories } from '@services/commonService';
import { onAddPomVisual, onUpdatePomVisual } from '@services/pomService';

const AddPomImage = ({ isUploadCLick, onCloseUpload, onddSucces }) => {
	const [errors, setErrors] = useState({});
	const [categories, setCategories] = useState([]);
	const [caption, setCaption] = useState('');
	const [selectedCategories, setSelectedCategories] = useState([]);
	const [documentUrl, setDocumentUrl] = useState(null);
	const isLoading = useSelector((store) => store.loaderStore);
	const dispatch = useDispatch();

	useEffect(() => {
		onFetchSubCategories();
	}, []);

	useEffect(() => {
		if (isUploadCLick !== 'ADD') {
			setCaption(isUploadCLick?.name);
			setSelectedCategories([
				{ value: isUploadCLick?.subCategoryId, label: isUploadCLick?.subCategoryName }
			]);
			setDocumentUrl(isUploadCLick?.documentResponse);
		}
	}, [isUploadCLick]);

	const onFetchSubCategories = async () => {
		try {
			dispatch(openLoader());
			const subCategories = await fetchSubCategories();
			const categories = subCategories
				? subCategories.map((item) => ({ value: item.id, label: item.name }))
				: [];

			setCategories(categories);
			dispatch(closeLoader());
		} catch (error) {
			dispatch(closeLoader());
			toastError(error.message);
		}
	};

	const isValidForm = () => {
		let newErrors = {};
		if (!caption) {
			newErrors = { ...newErrors, captionError: 'Caption is required' };
		}
		if (!selectedCategories[0]?.value) {
			newErrors = { ...newErrors, categoryIdError: 'Category is required' };
		}

		// if (isAdd && !body.documentDTO) {
		// 	newErrors = { ...newErrors, imageError: 'Photo is required' };
		// }

		setErrors(newErrors);
		return Object.keys(newErrors).length === 0;
	};

	const onImageUpload = async (data) => {
		setDocumentUrl(data);
	};

	const updatePomVisual = async (body) => {
		const { documentDTO, ...updatedDocumentDTO } = body;
		const bodyData = documentDTO?.base64Str ? body : { ...updatedDocumentDTO };
		return await onUpdatePomVisual(bodyData, isUploadCLick?.id);
	};

	const onPomSubmit = async () => {
		let body = {
			documentDTO: {
				...documentUrl
			},
			caption: caption,
			subCategoryId: selectedCategories[0]?.value
		};
		try {
			dispatch(openLoader());
			const isValid = isValidForm(body);
			if (!isValid) {
				dispatch(closeLoader());
				return;
			}
			const responseData =
				isUploadCLick === 'ADD' ? await onAddPomVisual(body) : await updatePomVisual(body);
			await onddSucces(responseData?.id);
			onCloseUpload();
		} catch {
			dispatch(closeLoader());
		}
	};

	return (
		<ModalContainer className="pom-upload-modal">
			<div className="common-popup pom-upload-modal border-0 shadow-24dp">
				<div className="common-popup-header d-flex justify-content-between">
					<div className="popup-tilte">
						<h3 className="semibold-16 mb-0">Add POM Visual</h3>
					</div>
					<div className="close-btn" onClick={onCloseUpload}>
						<img src={`${process.env.PUBLIC_URL}/icons/close.svg`} alt="close" />
					</div>
				</div>
				<div className="common-popup-body">
					<div className="row">
						<div className="col-md-4 pr-2">
							<div className="upload-section">
								{documentUrl ? (
									<>
										<img
											className="border-0"
											src={documentUrl?.docUrl || documentUrl?.base64Str}
											alt="edit"
										/>
										<ImageUpload
											size="sm"
											onUploadImage={onImageUpload}
											docType={'PRODUCT_DESIGN'}
											type={'image'}
											isEditable={true}
										/>
									</>
								) : (
									<ImageUpload
										size="sm"
										onUploadImage={onImageUpload}
										docType={'PRODUCT_DESIGN'}
										type={'image'}
									/>
								)}
							</div>
							{/* {errors.imageError && <p className="error">{errors.imageError}</p>} */}
						</div>
						<div className="col-md-8 pr-2">
							<div className="row">
								<div className="col-md-12">
									<div className="form-group">
										<label htmlFor="collection">Caption*</label>
										<input
											type="text"
											className="w-100"
											onChange={(e) => setCaption(e.target.value)}
											value={caption}
										/>
										{errors.captionError && (
											<p className="error">{errors.captionError}</p>
										)}
									</div>
								</div>
								<div className="col-md-12">
									<div className="form-group no-shadow-react-select size36">
										<label htmlFor="collection">Category*</label>
										<CustomSelectableDropdown
											allOptions={categories}
											setSelectedOptions={setSelectedCategories}
											selectedOptions={selectedCategories}
											isMulti={false}
										/>
										{errors.categoryIdError && (
											<p className="error">{errors.categoryIdError}</p>
										)}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="modal-footer">
					<div className="footer-buttons text-right">
						<button className="button gray-outline size32" onClick={onCloseUpload}>
							Cancel
						</button>
						<button className="button size32 ml-2" disabled={isLoading} onClick={onPomSubmit}>
							Add
						</button>
					</div>
				</div>
			</div>
		</ModalContainer>
	);
};

export default AddPomImage;
